import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Recs from 'core/components/Recs';
import { Container } from 'core/components/Recs/recsStyles';
import {
	SectionHeader,
	SectionTitle,
	SectionSubtitle,
} from 'core/styles';


const UserRecsTitle = ({ title, subTitle, ...props }) => {
	return (
		<SectionHeader {...props}>
			<SectionSubtitle>Just For You</SectionSubtitle>
			<SectionTitle>
				You may also like
			</SectionTitle>
		</SectionHeader>
	);
};

class UserRecs extends PureComponent {
	render() {
		const { show, strategy, noPadding, ...recProps } = this.props;
		if (show === false) return null;

		const renderTitle = "title" in recProps ? null : () => <UserRecsTitle />;

		return (
			<Container noPadding={noPadding}>
				<Recs
					minimum={3}
					strategy={strategy}
					renderTitle={renderTitle}
					{...recProps}
				/>
			</Container>
		);
	}
}

UserRecs.propTypes = {
	show: PropTypes.bool,
	noPadding: PropTypes.bool,
	strategy: PropTypes.string,
	title: PropTypes.string,
};

UserRecs.defaultProps = {
	show: true,
	strategy: 'aws_user_personalization',
};

export default UserRecs;
